var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',_vm._b({ref:"btn",on:{"click":function($event){$event.preventDefault();return _vm.clicked.apply(null, arguments)}}},'b-button',_vm.$attrs,false),[(!_vm.isLoading)?_vm._t("default"):_c('b-spinner',{staticStyle:{"width":"1rem","height":"1rem"},attrs:{"variant":_vm.$attrs['spinner-variant']}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }